















import { Component, Vue } from 'vue-property-decorator';
import AppLayout from '@/component/layout/app/index.vue';
import SelectMerchant from '@/view/passport/select-merchant.vue';
import Login from '@/view/passport/login.vue';
import Login2 from '@/view/passport/login2.vue';
import { State } from 'vuex-class';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

@Component({
  components: {
    AppLayout,
    Login,
    Login2,
    SelectMerchant,
  },
})
export default class App extends Vue {
  @State('is_logged_on') is_logged_on!: boolean;
  locale: any = zhCN;
  is_show_new_login_page: boolean = false;
  get layout() {
    const { meta } = this.$route;
    const { layout } = meta;
    return layout || 'AppLayout';
  }

  created() {
    this.is_show_new_login_page = this.$route.path.indexOf('login-mendian') !== -1;
  }
}
